interface DateRangePickerStyles {
  dateRangeWrapper: string
  calendarWrapper: string
  dateDisplay: string
  dateDisplayItem: string
  dateDisplayItemActive: string
  monthAndYearWrapper: string
  monthAndYearPickers: string
  nextPrevButton: string
  month: string
  weekDays: string
  weekDay: string
  days: string
  day: string
  dayNumber: string
  dayPassive: string
  dayToday: string
  dayStartOfWeek: string
  dayEndOfWeek: string
  daySelected: string
  dayDisabled: string
  dayStartOfMonth: string
  dayEndOfMonth: string
  dayWeekend: string
  dayStartPreview: string
  dayInPreview: string
  dayEndPreview: string
  dayHovered: string
  dayActive: string
  inRange: string
  endEdge: string
  startEdge: string
  prevButton: string
  nextButton: string
  selected: string
  months: string
  monthPicker: string
  yearPicker: string
  dateDisplayWrapper: string
  definedRangesWrapper: string
  staticRanges: string
  staticRange: string
  inputRanges: string
  inputRange: string
  inputRangeInput: string
  dateRangePickerWrapper: string
  staticRangeLabel: string
  staticRangeSelected: string
  monthName: string
  infiniteMonths: string
  monthsVertical: string
  monthsHorizontal: string
}

const styles: DateRangePickerStyles = {
  dateRangeWrapper: 'rdrDateRangeWrapper',
  calendarWrapper: 'rdrCalendarWrapper',
  dateDisplay: 'rdrDateDisplay',
  dateDisplayItem: 'rdrDateDisplayItem',
  dateDisplayItemActive: 'rdrDateDisplayItemActive',
  monthAndYearWrapper: 'rdrMonthAndYearWrapper',
  monthAndYearPickers: 'rdrMonthAndYearPickers',
  nextPrevButton: 'rdrNextPrevButton',
  month: 'rdrMonth',
  weekDays: 'rdrWeekDays',
  weekDay: 'rdrWeekDay',
  days: 'rdrDays',
  day: 'rdrDay',
  dayNumber: 'rdrDayNumber',
  dayPassive: 'rdrDayPassive',
  dayToday: 'rdrDayToday',
  dayStartOfWeek: 'rdrDayStartOfWeek',
  dayEndOfWeek: 'rdrDayEndOfWeek',
  daySelected: 'rdrDaySelected',
  dayDisabled: 'rdrDayDisabled',
  dayStartOfMonth: 'rdrDayStartOfMonth',
  dayEndOfMonth: 'rdrDayEndOfMonth',
  dayWeekend: 'rdrDayWeekend',
  dayStartPreview: 'rdrDayStartPreview',
  dayInPreview: 'rdrDayInPreview',
  dayEndPreview: 'rdrDayEndPreview',
  dayHovered: 'rdrDayHovered',
  dayActive: 'rdrDayActive',
  inRange: 'rdrInRange',
  endEdge: 'rdrEndEdge',
  startEdge: 'rdrStartEdge',
  prevButton: 'rdrPprevButton',
  nextButton: 'rdrNextButton',
  selected: 'rdrSelected',
  months: 'rdrMonths',
  monthPicker: 'rdrMonthPicker',
  yearPicker: 'rdrYearPicker',
  dateDisplayWrapper: 'rdrDateDisplayWrapper',
  definedRangesWrapper: 'rdrDefinedRangesWrapper',
  staticRanges: 'rdrStaticRanges',
  staticRange: 'rdrStaticRange',
  inputRanges: 'rdrInputRanges',
  inputRange: 'rdrInputRange',
  inputRangeInput: 'rdrInputRangeInput',
  dateRangePickerWrapper: 'rdrDateRangePickerWrapper',
  staticRangeLabel: 'rdrStaticRangeLabel',
  staticRangeSelected: 'rdrStaticRangeSelected',
  monthName: 'rdrMonthName',
  infiniteMonths: 'rdrInfiniteMonths',
  monthsVertical: 'rdrMonthsVertical',
  monthsHorizontal: 'rdrMonthsHorizontal',
}

export default styles
